/**
 * src/api/adminPanel.js
 * Vistas de detalle del panel de control global (drill-down del Dashboard).
 */
import api from './client'

export const getActividad = (dias = 7) =>
  api.get('/admin/panel/actividad', { params: { dias } }).then(r => r.data)

export const getActividadDia = (fecha) =>
  api.get('/admin/panel/actividad/dia', { params: { fecha } }).then(r => r.data)

export const getFamilias = () =>
  api.get('/admin/panel/familias').then(r => r.data)

export const getSchedulerDetalle = () =>
  api.get('/admin/panel/scheduler').then(r => r.data)

export const getAlertas = (params = {}) =>
  api.get('/admin/panel/alertas', { params }).then(r => r.data)

export const getEmbudo = (dias = 30) =>
  api.get('/admin/panel/embudo', { params: { dias } }).then(r => r.data)

export const getUso = (dias = 30) =>
  api.get('/admin/panel/uso', { params: { dias } }).then(r => r.data)

export const getUsoAgregado = (dias = 30) =>
  api.get('/admin/panel/uso/agregado', { params: { dias } }).then(r => r.data)

export const getUsoCliente = (clienteId, dias = 30) =>
  api.get(`/admin/panel/uso/cliente/${clienteId}`, { params: { dias } }).then(r => r.data)

export const getUsoHorarios = (dias = 30) =>
  api.get('/admin/panel/uso/horarios', { params: { dias } }).then(r => r.data)

export const getCifrasLanding = (diasOc = 30) =>
  api.get('/admin/panel/cifras-landing', { params: { dias_oc: diasOc } }).then(r => r.data)

// Estado: lo que pide atención ahora mismo, y las cifras del día al lado.
export const getEstado = () =>
  api.get('/admin/panel/estado').then(r => r.data)

// «Actualizar»: re-mide las alertas re-medibles y cierra las que ya no se cumplen.
export const postEstadoRechequear = () =>
  api.post('/admin/panel/estado/rechequear').then(r => r.data)

// «Marcar resuelta»: cierre manual de una alerta que el panel no puede re-medir.
export const postResolverAlertaEstado = (clave) =>
  api.post(`/admin/panel/estado/alertas/${clave}/resolver`).then(r => r.data)

// Frescura: qué tiene cada tenant por actualizar. Endpoint APARTE del de
// /estado a propósito — ver el porqué en app/routers/admin_panel.py.
export const getFrescura = () =>
  api.get('/admin/panel/frescura').then(r => r.data)

// Ejecuciones: una sola línea con lo programado y lo ejecutado.
export const getEjecuciones = ({ tenant, tipo, soloError, dias = 7 } = {}) =>
  api.get('/admin/panel/ejecuciones', {
    params: {
      dias,
      ...(tenant ? { tenant } : {}),
      ...(tipo ? { tipo } : {}),
      ...(soloError ? { solo_error: true } : {}),
    },
  }).then(r => r.data)

// Cómo le va a un cliente: lo que le falta al payload de /admin/clientes/{id}.
export const getFichaCliente = (clienteId) =>
  api.get(`/admin/panel/cliente/${clienteId}/ficha`).then(r => r.data)
